import { Loading } from '@uplift/pages';
import { ScrollableView } from '@uplift/ui-v2';
import { useMemo, useReducer } from 'react';
import { ClinicalNotesContext, clinicalNotesReducer } from './clinical-notes.context';
import { ClinicalNotes } from './clinical-notes.main';
import { useClinicalNotes } from './hooks';


export const ClinicalNotesPageContent: React.VFC<{ appointmentId: string }> = ({ appointmentId }) => {
  const [ state, dispatch ] = useReducer(clinicalNotesReducer, null);
  const ctx = useMemo(() => ({ state, dispatch }), [ state, dispatch ]);
  const { loading } = useClinicalNotes(appointmentId, dispatch);

  return (
    <ClinicalNotesContext.Provider value={ctx}>
      <ScrollableView flex={1}>
        {loading && <Loading fixed />}
        {!loading && <ClinicalNotes />}
      </ScrollableView>
    </ClinicalNotesContext.Provider>
  );
};
